module.exports = __webpack_public_path__ + "img/sort-item-gray.2944b8e9.svg";